import { Component, inject, Signal } from '@angular/core';
import { BackButtonComponent } from "./back-button/back-button.component";
import { SearchComponent } from "./search/search.component";
import { HomeButtonComponent } from "./home-button/home-button.component";
import { MobileButtonComponent } from './mobile-button/mobile-button.component';
import { LayoutService } from '@services/layout.service';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [
    BackButtonComponent, 
    SearchComponent, 
    HomeButtonComponent, 
    MobileButtonComponent
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.css'
})
export class NavigationComponent {

  // STATE
  public readonly isMobile: Signal<boolean> = inject(LayoutService).isMobile;
  
}
